import { Decimal } from 'decimal.js';
export function sumDecimals(decimals) {
    return decimals.reduce((acc, curr) => acc.add(curr), Decimal(0));
}
// Floating-point products of prices and quantities drift (0.1 * 3 = 0.30000000000000004): sum them
// exactly and round to the cent, as every amount the API accepts.
export function sumToCents(amounts) {
    return sumDecimals(amounts.map((amount) => new Decimal(amount)))
        .toDecimalPlaces(2)
        .toNumber();
}
